import { useMutation } from '@tanstack/react-query';
import { showcaseApi } from '../api/showcaseApi';
import type { ApiError, ReportExportFormat } from '../types/showcase';

/** C082 리포트 데모(read-only) — POST .../report/export?format= (queue #646 §R646-2). */
export function useReportExport() {
  return useMutation<Blob, ApiError, ReportExportFormat>({
    mutationFn: (format) => showcaseApi.reportExport(format),
    mutationKey: ['common-showcase', 'report', 'export'],
  });
}
